export const ORDER_MOVING_CLOSET = {
  MUTATIONS: {
    SET_DATA: 'order-moving-closet-set-data'
  },
  ACTIONS: {
    INIT_DATA: 'order-moving-closet-action-init-data'
  },
  GETTERS: {
    DATA: 'order-moving-closet-get-data'
  }
}
